/* Katalog teması — iç sayfa etkileşimleri
   Ürün galerisi, varyant seçimi (fiyat/görsel güncelleme), akordeonlar,
   koleksiyon sıralaması ve dil seçici. Sepet/satın alma yoktur. */
(function () {
  'use strict';

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /* Görseli değiştirir. srcset/sizes mutlaka temizlenmeli: Shopify'ın image_tag
     filtresi srcset üretir ve tarayıcı src yerine srcset'i kullanır — yalnızca
     src güncellenirse ekranda eski görsel kalır. */
  function setImage(img, src, alt) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.alt = alt || '';
  }

  /* ---------- Yatay kaydırma (swipe) yardımcısı ----------
     Dinleyiciler passive: dikey kaydırmayı asla engellemez.
     Yalnızca yatay hareket dikeyden baskınsa kaydırma sayılır. */
  function onSwipe(el, handler) {
    var x0 = null, y0 = null, t0 = 0;
    el.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
      x0 = null;
      if (dt > 800 || Math.abs(dx) < 40) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
      handler(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------- Görsel büyüteci (lightbox) ---------- */
  var lb = null, lbItems = [], lbIdx = 0, lbLastFocus = null;

  function buildLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'rt-lb';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<div class="rt-lb__backdrop" data-rt-lb-close></div>' +
      '<div class="rt-lb__panel" role="dialog" aria-modal="true" aria-label="Ürün görselleri">' +
        '<button type="button" class="rt-lb__close" data-rt-lb-close aria-label="Kapat">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"></path></svg>' +
        '</button>' +
        '<button type="button" class="rt-lb__nav rt-lb__nav--prev" data-rt-lb-step="-1" aria-label="Önceki görsel">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"></path></svg>' +
        '</button>' +
        '<img class="rt-lb__img" alt="">' +
        '<button type="button" class="rt-lb__nav rt-lb__nav--next" data-rt-lb-step="1" aria-label="Sonraki görsel">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg>' +
        '</button>' +
        '<div class="rt-lb__count" data-rt-lb-count></div>' +
      '</div>';
    document.body.appendChild(lb);

    lb.querySelectorAll('[data-rt-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    lb.querySelectorAll('[data-rt-lb-step]').forEach(function (el) {
      el.addEventListener('click', function () {
        lbShow(lbIdx + parseInt(el.getAttribute('data-rt-lb-step'), 10));
      });
    });
    onSwipe(lb, function (dir) { lbShow(lbIdx + dir); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('rt-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
      else if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
    });
    return lb;
  }

  function lbShow(i) {
    if (!lbItems.length) return;
    lbIdx = (i + lbItems.length) % lbItems.length;
    setImage(lb.querySelector('.rt-lb__img'), lbItems[lbIdx].src, lbItems[lbIdx].alt);
    var c = lb.querySelector('[data-rt-lb-count]');
    if (c) c.textContent = lbItems.length > 1 ? (lbIdx + 1) + ' / ' + lbItems.length : '';
    lb.querySelectorAll('.rt-lb__nav').forEach(function (n) {
      n.hidden = lbItems.length < 2;
    });
  }

  function openLightbox(items, start) {
    lbItems = items;
    buildLightbox();
    lbLastFocus = document.activeElement;
    lbShow(start || 0);
    lb.classList.add('rt-open');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rt-lb-lock');
    var close = lb.querySelector('.rt-lb__close');
    if (close) close.focus();
  }

  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('rt-open');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('rt-lb-lock');
    if (lbLastFocus && lbLastFocus.focus) lbLastFocus.focus();
  }

  /* ---------- Ürün galerisi ---------- */
  function initGallery(scope) {
    scope.querySelectorAll('[data-rt-gallery]').forEach(function (gal) {
      if (gal.dataset.rtGalleryReady) return;
      gal.dataset.rtGalleryReady = '1';

      var main = gal.querySelector('[data-rt-gallery-main]');
      if (!main) return;
      var thumbs = [].slice.call(gal.querySelectorAll('.rt-thumb'));
      var strip = gal.querySelector('.rt-gallery__thumbs');
      var counter = gal.querySelector('[data-rt-gallery-count]');

      var items = thumbs.map(function (t) {
        return { src: t.getAttribute('data-src'), alt: t.getAttribute('data-alt') || '' };
      });
      if (!items.length) {
        var only = main.querySelector('img');
        if (only) items = [{ src: only.getAttribute('src'), alt: only.getAttribute('alt') || '' }];
      }
      if (!items.length) return; // görselsiz ürün: yer tutucu kalır

      var idx = 0;

      function revealThumb(i) {
        if (!strip || !thumbs[i]) return;
        var t = thumbs[i];
        strip.scrollTo({
          left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }

      function show(i) {
        idx = (i + items.length) % items.length;
        var img = main.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          main.insertBefore(img, main.firstChild);
        }
        setImage(img, items[idx].src, items[idx].alt);
        thumbs.forEach(function (t, k) { t.classList.toggle('rt-active', k === idx); });
        if (counter) counter.textContent = (idx + 1) + ' / ' + items.length;
        revealThumb(idx);
      }

      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k); });
      });

      if (items.length > 1) onSwipe(main, function (dir) { show(idx + dir); });

      // Ana görsel tıklanınca büyüteç açılır
      main.classList.add('rt-gallery__main--zoomable');
      main.setAttribute('role', 'button');
      main.setAttribute('tabindex', '0');
      main.setAttribute('aria-label', 'Görseli büyüt');
      main.addEventListener('click', function () { openLightbox(items, idx); });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(items, idx);
        }
      });
    });
  }

  /* ---------- Akordeonlar ---------- */
  function initAccordions(scope) {
    scope.querySelectorAll('.rt-acc__btn').forEach(function (btn) {
      if (btn.dataset.rtAccBound) return;
      btn.dataset.rtAccBound = '1';
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('rt-open', !open);
      });
    });
  }

  /* ---------- Varyant seçimi (yalnızca görüntüleme) ---------- */
  function initVariants(scope) {
    scope.querySelectorAll('[data-rt-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-rt-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var priceEl = root.querySelector('[data-rt-price]');
      var oldEl = root.querySelector('[data-rt-old-price]');
      var saveEl = root.querySelector('[data-rt-save]');
      var mainMedia = document.querySelector('[data-rt-gallery-main]');

      function update() {
        var chosen = [];
        root.querySelectorAll('[data-rt-option]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          chosen[parseInt(group.dataset.rtOption, 10)] = checked ? checked.value : null;
        });

        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;

        if (priceEl && !priceEl.classList.contains('rt-pdp__price--ask')) {
          priceEl.textContent = money(match.price);
        }

        if (oldEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            oldEl.textContent = money(match.compare_at_price);
            oldEl.hidden = false;
            if (saveEl) {
              saveEl.textContent = '-' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
              saveEl.hidden = false;
            }
          } else {
            oldEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }

        if (match.featured_image && mainMedia) {
          // Yalnızca görseli değiştir: sayaç rozeti gibi kardeş öğeler korunur
          var img = mainMedia.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            mainMedia.insertBefore(img, mainMedia.firstChild);
          }
          setImage(img, match.featured_image, match.title);
        }

        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('[data-rt-option] input').forEach(function (input) {
        input.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---------- Dil seçici ---------- */
  function initLocalization(scope) {
    scope.querySelectorAll('.rt-loc__select').forEach(function (select) {
      if (select.dataset.rtLocBound) return;
      select.dataset.rtLocBound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Koleksiyon sıralaması ---------- */
  function initSort(scope) {
    scope.querySelectorAll('[data-rt-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function init(scope) {
    var s = scope || document;
    initGallery(s);
    initAccordions(s);
    initVariants(s);
    initSort(s);
    initLocalization(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
